import React, {Component} from 'react';
import {Button, Input, Select, Icon, Table, Popconfirm, Modal, message} from 'antd';
import {Redirect} from 'react-router';
import './style.less';
import utils from '../../../utils/common';
import GroupGoods from '../packageMangement/groupgoods';

const Option = Select.Option;
class PackageList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      isLoading: true,
      packageData: [],
      goodsData: [],
      modelVisible: false, //组合商品弹层
      search: {
        package_name: '',
        package_status: '',
        procurement_level: ''
      },
      pagination: {
        page_size: 10,
        current_page: 1,
        total: '',
        onChange: this.changePage
      }
    };
  }
  componentWillMount() {
    window.localStorage.removeItem('locaParams');
    this.loadList();
  }
  loadList() {
    let params = {
      ...this.state.search,
      page_size: this.state.pagination.page_size,
      current_page: this.state.pagination.current_page
    };
    params = utils.dealElement(params);
    window.api('eps.getgoodspackagelist', params).then(rs => {
      const pagination = Object.assign(this.state.pagination, {total: Number(rs.total_result)});
      this.setState({packageData: rs.goods_package_list, pagination, isLoading: false});
    }).catch(error => {
      if (error.service_error_code === 'EPS000000801') {
        this.setState({redirect: true});
      }
      message.error(error.service_error_message);
      this.setState({isLoading: false});
    });
  }
  changePage = (page) => {
    page = page === 0 ? 1 : page;
    const pagination = Object.assign(this.state.pagination, {current_page: page});
    this.setState({pagination});
    this.loadList();
  }
  createEvent = (id) => {
    window.localStorage.removeItem('locaParams');
    this.props.history.push('/main/selectgoods', {package_id: id});
  }
  handleChange = (type, text) => {
    const search = this.state.search;
    if (text === undefined) return;
    switch (typeof text) {
      case 'object':
        Object.assign(search, {[type]: text.target.value});
        break;
      case 'number':
        Object.assign(search, {[type]: text});
        break;
      default:
        Object.assign(search, {[type]: text});
        break;
    }
    this.setState({search});
  }
  //打开组合商品弹层
  packageGroupEvent = (record) => {
    window.api('eps.getgoodspackageinfo', {id: record.id}).then(rs => {
      this.setState({modelVisible: true, goodsData: rs.goods_package.goods_package_detail_list});
    }).catch(error => {
      if (error.service_error_code === 'EPS000000801') {
        this.setState({redirect: true});
      }
      message.error(error.service_error_message);
    });
  }
  close = () => {
    this.setState({modelVisible: false});
  }
  editEvent = (item, type) => {
    this.props.history.push({pathname: '/main/editgoods', state: {id: item.id, type}});
  }
  //是否需要下架
  confirm = (record) => {
    const status = Number(record.package_status) === 0 ? 1 : 0;
    window.api('eps.modgoodspackage', {package_id: record.id, package_status: status}).then(rs => {
      message.success(rs.service_error_message);
      this.loadList();
    }).catch(error => {
      if (error.service_error_code === 'EPS000000801') {
        this.setState({redirect: true});
      }
      message.error(error.service_error_message);
    });
  }
  searchEvent = () => {
    this.loadList();
  }
  // 重置搜索条件
  resetFilter = () => {
    this.setState({
      search: {
        package_name: '',
        package_status: '',
        procurement_level: ''
      },
      pagination: Object.assign({}, this.state.pagination, { current_page: 1 })
    }, () => {
      this.loadList();
    });
  }
  render() {
    const {
      isLoading,
      packageData,
      pagination,
      redirect,
      search,
      goodsData
    } = this.state;
    if (redirect) return (<Redirect to="/login" />);
    const columns = [
      {
        title: '套餐名称',
        key: 'package_name',
        dataIndex: '',
        render: (record) => (
          <span>
            <img src={record.package_picture} className="img-ico" />
            {record.package_name}
          </span>
        )
      },
      {
        title: '套餐价格',
        key: 'package_amt',
        dataIndex: 'package_amt'
      },
      {
        title: '套餐等级',
        key: 'procurement_level',
        dataIndex: 'procurement_level',
        render: (record) => (
          <span>{window.common.levelData[record]}</span>
        )
      },
      {
        title: '套餐状态',
        key: 'package_status',
        dataIndex: 'package_status',
        render: (record) => (
          Number(record) === 0
            ? <span className="status-badge green">上架中</span>
            : <span className="status-badge red">已下架</span>
        )
      },
      {
        title: '已售数量',
        key: 'sell_out',
        dataIndex: 'sell_out'
      },
      {
        title: '操作',
        key: 'operation',
        dataIndex: '',
        render: (record) => (
          <div className="opearte-blocks">
            <span className="ml10" onClick={() => this.packageGroupEvent(record)}>查看商品组合</span>
            <span onClick={() => this.editEvent(record, 1)}>编辑</span>
            <Popconfirm
              title={Number(record.package_status) === 0 ? '是否需要下架？' : '是否需要上架？'}
              onConfirm={() => this.confirm(record)}
              okText="是"
              cancelText="否"
            >
              <span className="ml10">{Number(record.package_status) === 0 ? '下架' : '重新上架'}</span>
            </Popconfirm>
          </div>
        )
      }
    ];
    return (
      <div className="package-blocks">
        <Modal
          title="查看商品组合"
          width={800}
          visible={this.state.modelVisible}
          onCancel={this.close}
          footer={null}
        >
          <GroupGoods goodsData={goodsData} />
        </Modal>
        <div className="nav-items">
          <div className="tap-items">
            <span className="active">套餐管理</span>
          </div>
          <Button type="primary" onClick={this.createEvent.bind(this, 0)}>创建套餐</Button>
        </div>
        <dl className="search-blocks">
          <dd>套餐名称：
            <Input onChange={this.handleChange.bind(this, 'package_name')} placeholder="请输入套餐名称" value={search.package_name} suffix={<Icon type="search" className="certain-category-icon" />} />
          </dd>
          <dd>套餐状态：
            <Select value={search.package_status} onChange={this.handleChange.bind(this, 'package_status')} placeholder="请选择" className="w180">
              <Option value="">全部</Option>
              <Option value={0}>上架中</Option>
              <Option value={1}>已下架</Option>
            </Select>
          </dd>
          <dd>套餐等级：
            <Select value={search.procurement_level} onChange={this.handleChange.bind(this, 'procurement_level')} placeholder="请选择套餐等级" className="w180">
              <Option value="">全部</Option>
              {
                window.common.levelData.map((item, index) => (
                  <Option key={index} value={index}>{item}</Option>
                ))
              }
            </Select>
          </dd>
          <dt>
            <Button type="primary" onClick={this.searchEvent.bind(this)}>查询</Button>
            <Button onClick={this.resetFilter} style={{ marginLeft: 8 }}>重置</Button>
          </dt>
        </dl>
        <Table
          columns={columns}
          dataSource={packageData}
          pagination={pagination}
          className="table-blocks mt30"
          rowKey={record => record.id}
          loading={isLoading}
          scroll={{x: 1000}}
        />
      </div>
    );
  }
}
export default PackageList;



// WEBPACK FOOTER //
// ./src/containers/backEnd/packageMangement/packagelist.jsx